import { render, staticRenderFns } from "./SurgeriesDesktop.vue?vue&type=template&id=6801e2ba"
import script from "./SurgeriesDesktop.vue?vue&type=script&lang=js"
export * from "./SurgeriesDesktop.vue?vue&type=script&lang=js"
import style0 from "./SurgeriesDesktop.vue?vue&type=style&index=0&id=6801e2ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports